import { createBooleanSimpleFilterDefinition } from '@/sections/insights/queryBuilder/entities/common/createBooleanSimpleFilterDefinition';

/**
 * AD Object ACL-Protected field definition
 * Boolean field with Yes/No dropdown for ACL protection status filtering
 */
export const ADObjectACLProtected = createBooleanSimpleFilterDefinition(
  'isaclprotected',
  'ACL Protected'
);
